import { Grey_ } from 'monica-alexandria';
import styled from 'styled-components';

const OfferPreviewBankTransferOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: ${p => p.theme.overlay};
    display: grid;
    place-items: center;
    z-index: 60;
    padding: 1.2rem;

    @media print {
        display: none;
    }
`;

const OfferPreviewBankTransferCard = styled.div`
    width: min(100%, 52rem);
    background: ${p => p.theme.background};
    border: 0.1rem solid ${p => p.theme.mid};
    border-radius: var(--smallRadius);
    padding: 1.6rem;
    display: grid;
    gap: 1.2rem;

    button {
        justify-content: center;
    }
`;

const OfferPreviewBankTransferRows = styled.div`
    display: grid;
    gap: 1rem;
`;

const OfferPreviewBankTransferBank = styled.div`
    border: 0.1rem solid ${p => p.theme.mid};
    border-radius: var(--smallRadius);
    padding: 1rem;
    display: grid;
    gap: 0.8rem;
`;

const OfferPreviewBankTransferRow = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 0.8rem;
    border-bottom: 0.1rem dashed ${p => p.theme.mid};
    padding-bottom: 0.6rem;

    p,
    h6 {
        margin: 0;
    }
`;

export default function Offer_Bank_Transfer(props) {
    return (
        <OfferPreviewBankTransferOverlay>
            <OfferPreviewBankTransferCard>
                <h4>{props.copy.bankTransferDetails}</h4>
                <p>{props.copy.bankTransferText}</p>
                <OfferPreviewBankTransferRows>
                    <OfferPreviewBankTransferBank>
                        <h6>Τράπεζα Πειραιώς</h6>
                        <OfferPreviewBankTransferRow>
                            <p>{props.copy.beneficiary}</p>
                            <h6>DO IT FOR ME ΙΚΕ</h6>
                        </OfferPreviewBankTransferRow>
                        <OfferPreviewBankTransferRow>
                            <p>{props.t('IBAN')}</p>
                            <h6>GR81 0172 6100 0056 1009 5565 949</h6>
                        </OfferPreviewBankTransferRow>
                    </OfferPreviewBankTransferBank>
                    <OfferPreviewBankTransferBank>
                        <h6>Εθνική Τράπεζα</h6>
                        <OfferPreviewBankTransferRow>
                            <p>{props.copy.beneficiary}</p>
                            <h6>DO IT FOR ME ΙΚΕ</h6>
                        </OfferPreviewBankTransferRow>
                        <OfferPreviewBankTransferRow>
                            <p>{props.t('IBAN')}</p>
                            <h6>GR60 0110 2010 0000 2010 1944 336</h6>
                        </OfferPreviewBankTransferRow>
                    </OfferPreviewBankTransferBank>
                    <OfferPreviewBankTransferRow>
                        <p>{props.copy.reference}</p>
                        <h6>{props.offerCode || '—'}</h6>
                    </OfferPreviewBankTransferRow>
                    <OfferPreviewBankTransferRow>
                        <p>{props.copy.amount}</p>
                        <h6>{`€ ${props.amount.toFixed(2)}`}</h6>
                    </OfferPreviewBankTransferRow>
                </OfferPreviewBankTransferRows>
                <Grey_
                    text={props.copy.close}
                    onClick={props.onClose}
                ></Grey_>
            </OfferPreviewBankTransferCard>
        </OfferPreviewBankTransferOverlay>
    );
}
